import {CheckIcon, CommentIcon, DotFillIcon, FileDiffIcon, ShieldIcon} from '@primer/octicons-react'
import type {Icon} from '@primer/octicons-react'
import type {ReviewState, PendingReviewRequest} from '../../../page-data/payloads/review-requests'

export function reviewState(state: ReviewState): {icon: Icon; className: string; label: string} {
  switch (state) {
    case 'approved':
      return {icon: CheckIcon, className: 'color-fg-success', label: 'Approved'}
    case 'changes_requested':
      return {icon: FileDiffIcon, className: 'color-fg-danger', label: 'Changes requested'}
    case 'commented':
      return {icon: CommentIcon, className: 'color-fg-muted', label: 'Commented'}
    case 'dismissed':
      return {icon: ShieldIcon, className: 'color-fg-muted', label: 'Dismissed'}
    default:
      return {icon: DotFillIcon, className: 'color-fg-attention', label: 'Pending'}
  }
}

export function reviewStateTooltip(state: ReviewState, name: string): string {
  switch (state) {
    case 'approved':
      return `${name} approved these changes`
    case 'changes_requested':
      return `${name} requested changes`
    case 'commented':
      return `${name} left review comments`
    case 'dismissed':
      return `${name}'s review was dismissed`
    default:
      return `Awaiting requested review from ${name}`
  }
}

export function deferredTooltip(deferredType: 'codeowner' | 'copilot', name: string): string {
  if (deferredType === 'copilot') {
    return `${name} will automatically review once the pull request is marked ready for review`
  }
  return `${name} will be requested when the pull request is marked ready for review`
}

export function codeOwnerTooltip(request: PendingReviewRequest): string {
  const name = request.reviewer.displayLogin
  if (request.isCodeOwnerFromDelegation && request.delegatedFromTeam) {
    return `${name} is a code owner automatically assigned from ${request.delegatedFromTeam.displayLogin}`
  }
  return `${name} is a code owner`
}
